module.exports = __webpack_public_path__ + "img/icon-x.d6698d6c.svg";